import { lazy } from "react";

// Lazy load components with preloading capability
export const createLazyComponent = (importFunc, preload = false) => {
  const LazyComponent = lazy(importFunc);

  // Add preload method to the component
  LazyComponent.preload = importFunc;

  // Preload immediately if requested
  if (preload) {
    importFunc();
  }

  return LazyComponent;
};

// Create lazy components
export const PDFViewer = createLazyComponent(
  () => import("../screens/PDFViewerScreen"),
);

export const AuthenticationCard = createLazyComponent(
  () => import("../components/AuthenticationCard"),
  true, // Preload this component since it's used on the main route
);

export const MemberPDFViewer = createLazyComponent(
  () => import("../screens/MemberPDFViewerScreen"),
);

export const Settings = createLazyComponent(
  () => import("../components/Settings"),
);

// Preload components on user interaction (hover, focus, etc.)
export const preloadComponent = (component) => {
  if (component.preload) {
    component.preload();
  }
};

// Preload all components after initial load
export const preloadAllComponents = () => {
  setTimeout(() => {
    PDFViewer.preload();
    MemberPDFViewer.preload();
    Settings.preload();
  }, 2000); // Preload after 2 seconds
};
